import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { CoreUtils, ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import { StateType } from '~/redux/types';
import { GameCenterViewType } from '~/views/pages/gameCenter/enums';

const LIVE_GAME_ROUTES = [GameCenterViewType.SUMMARY, GameCenterViewType.BOXSCORE, GameCenterViewType.PLAYBYPLAY];
const POST_GAME_ROUTES = [GameCenterViewType.SUMMARY, GameCenterViewType.BOXSCORE, GameCenterViewType.PLAYBYPLAY];

const isValidRoute = (gameState: ShortCodeEnums.GameState, view: GameCenterViewType): boolean => {
    let valid = true;
    if (gameState === undefined) {
        valid = false;
    } else if (CoreUtils.isPregame(gameState) && view !== undefined) {
        valid = false;
    } else if (CoreUtils.isGameLive(gameState) && view !== undefined && !LIVE_GAME_ROUTES.includes(view)) {
        valid = false;
    } else if (CoreUtils.isPostGame(gameState) && view !== undefined && !POST_GAME_ROUTES.includes(view)) {
        valid = false;
    }
    return valid;
};

export const useValidGameCenterRoute = (): boolean => {
    const navigate = useNavigate();
    const gameState = useSelector((state: StateType) => state.gameCenter?.gameState);
    const params = useParams();
    const { date, gameId, matchup, month, year } = params;
    const view = params.view as GameCenterViewType;
    const [valid, setValid] = useState(isValidRoute(gameState, view));

    // We need navigate(...) to be in an effect
    useEffect(() => {
        const validRoute = isValidRoute(gameState, view);
        setValid(validRoute);

        const gameCenterBaseUrl = `/gamecenter/${matchup}/${year}/${month}/${date}/${gameId}`;
        if (!validRoute) {
            if (CoreUtils.isPregame(gameState)) {
                navigate(gameCenterBaseUrl, { replace: true });
            } else if (CoreUtils.isGameLive(gameState)) {
                navigate(`${gameCenterBaseUrl}/${GameCenterViewType.SUMMARY}`, { replace: true });
            } else if (CoreUtils.isPostGame(gameState)) {
                navigate(`${gameCenterBaseUrl}/${GameCenterViewType.SUMMARY}`, { replace: true });
            }
        }
    }, [date, gameId, gameState, matchup, month, navigate, view, year]);

    return valid;
};
